import { render, staticRenderFns } from "./BuildingUpgrade.vue?vue&type=template&id=1973c435&"
import script from "./BuildingUpgrade.vue?vue&type=script&lang=js&"
export * from "./BuildingUpgrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports